import { AppContext } from '@/store';
import { Theme } from '@/utils/constants';
import React, { memo, useContext } from 'react';
import Jumplinks from './Jumplinks';
import { JumplinksProps } from './Jumplinks.interface';

const JumplinksContainer = ({
  title = '',
  theme = Theme.dark,
  className,
}: Partial<JumplinksProps>) => {
  const { state } = useContext(AppContext);

  return (
    <div data-testid="qa-jumplinks-container" className={className} style={{ width: '100%' }}>
      <Jumplinks title={title} elements={state.jumplinks} theme={theme} />
    </div>
  );
};

export default memo(JumplinksContainer);
